import firebase_api from "@/firebase/firebase_api"
import firebase from 'firebase/app';
const object = {
    data: {

    },
    async test() {
        var db = firebase_api.api.getDb();
        var idClub= "Mon_Club_Nacry";

        await db.collection("club").doc(idClub).get().then(async(docClub)=>{
            if (docClub.exists) {
              
                var userId = docClub.data().users[firebase.auth().currentUser.uid].id;
                await db.collection("credit").doc(userId).get().then(async(credit)=>{
                    if (credit.exists) {
                        var solde = credit.data().credit - 1;
                        await credit.ref.update({
                            credit: solde
                        })
                    }
                    else
                        return -1;
                        
                })
            }
            return -1;
        })

    },
    addEvent (creditDoc, idPayment, type, fct) {
     
        if (type==0) {
            var credit = 3;
            var account = 5;
        }  
        else if (type==1) {
            var credit = 15;
            var account = 20;
        }
            
        else if (type==2) {
            var credit = 50;
            var account = 50;
        }
        else if (type==-1) {
            var credit = -1;
            var account = 0;
        }  
            if (type >= 0) {
                creditDoc.collection("events").doc(idPayment).set ({
                    type: type,
                    account: account,
                    credit: credit,
                    state: 0,
                    id: idPayment
                }).then(()=>{
                    fct(creditDoc.collection("events").doc(idPayment));
                })
            }
            else {
               
                creditDoc.collection("events").add({
                    type: type,
                    account: account,
                    credit: credit,
                    state: 0
                }).then((addEvent)=>{
                    fct(creditDoc.collection("events").doc(addEvent.id));
                })
            }
    },
    add(idPayment, type, idUser, fct) {
        var docCredit = firebase_api.api.getDb().collection("credit").doc(idUser);
            docCredit.get().then(credit=>{
                if (!credit.exists) {
                    var creditData = {
                        credit: 0,
                        free: 0
                    }
                    if (creditData.free>0) {
                        creditData.free--;
                    }
                    docCredit.set(creditData).then(()=>{
                            this.addEvent(docCredit, idPayment, type, (docEvent)=>{
                                fct(docEvent);
                            })
                    })
                }
                else {
                    this.addEvent(docCredit, idPayment, type, (docEvent)=>{
                        fct(docEvent);
                    })
                }
            })
    }


}

export default {
    object: object
}